"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _BigPointToBeEarned = _interopRequireDefault(require("./BigPointToBeEarned.proptypes"));
var _constant = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var BigPointsStyle = _styledComponents.default.img.withConfig({
  displayName: "BigPointToBeEarned__BigPointsStyle",
  componentId: "sc-2cl1ph-0"
})(["width:100%;"]);
var BigPoints = function BigPoints() {
  var coinSrc = 'https://storage.googleapis.com/static.airasia.com/design/icons/system/airasia-points.png';
  return /*#__PURE__*/_react.default.createElement(BigPointsStyle, {
    src: coinSrc,
    alt: "points logo"
  });
};
var BigPointIconWrapper = _styledComponents.default.span.withConfig({
  displayName: "BigPointToBeEarned__BigPointIconWrapper",
  componentId: "sc-2cl1ph-1"
})(["width:", ";height:", ";margin-right:", ";display:inline-flex;align-items:center;img{position:relative;bottom:-", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.normal;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.tiny;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.micro;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.micro;
});
BigPointIconWrapper.displayName = 'BigPointIcon';
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "BigPointToBeEarned__Wrapper",
  componentId: "sc-2cl1ph-2"
})(function (_ref5) {
  var includedInPriceHeader = _ref5.includedInPriceHeader;
  return "\n  display: flex;\n \n    ".concat(includedInPriceHeader ? "\n        flex-direction: row \n    " : "flex-direction: column ", "\n  \n");
});
var TextWrapper = _styledComponents.default.div.withConfig({
  displayName: "BigPointToBeEarned__TextWrapper",
  componentId: "sc-2cl1ph-3"
})(["font-family:", ";font-size:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontFamily.default;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.XSmall;
});
TextWrapper.displayName = 'TextWrapper';
var EarnedPointText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "BigPointToBeEarned__EarnedPointText",
  componentId: "sc-2cl1ph-4"
})(["font-weight:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeight.bold;
});
EarnedPointText.displayName = 'EarnedPointText';
var MultiplierText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "BigPointToBeEarned__MultiplierText",
  componentId: "sc-2cl1ph-5"
})(["font-weight:", ";font-size:", ";color:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeight.bold;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSize.medium;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.tertiary;
});
MultiplierText.displayName = 'MultiplierText';
var escapeRegExp = function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};

var replaceByJSX = function replaceByJSX(str, jsxMapping) {
  var pattern = new RegExp(Object.keys(jsxMapping).map(function (key) {
    return "(".concat(escapeRegExp(key), ")");
  }).join('|'), 'g');
  var matches = str.match(pattern);
  var parts = str.split(pattern);
  if (!matches) {
    return str;
  }
  return parts.map(function (part, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react.default.createElement(_react.Fragment, {
        key: index
      }, matches.includes(part) ? jsxMapping[part] : part)
    );
  });
};
var BigPointToBeEarned = function BigPointToBeEarned(_ref12) {
  var template = _ref12.template,
    pointTemplate = _ref12.pointTemplate,
    pointValue = _ref12.pointValue,
    multiplierTemplate = _ref12.multiplierTemplate,
    multiplierValue = _ref12.multiplierValue,
    theme = _ref12.theme,
    customProperties = _ref12.customProperties,
    accessible = _ref12.accessible,
    includedInPriceHeader = _ref12.includedInPriceHeader,
    isHotel = _ref12.isHotel;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';
  var getComponent = function getComponent() {
    var _jsxMapping;
    var earnedPoints;
    // eslint-disable-next-line react/prop-types
    if (pointValue && pointTemplate && pointTemplate.includes(_constant.POINT_PLACEHOLDER)) {
      if (!isHotel) {
        earnedPoints = replaceByJSX(pointTemplate, (0, _defineProperty2.default)({}, _constant.POINT_PLACEHOLDER, /*#__PURE__*/_react.default.createElement(EarnedPointText, {
          accessible: false,
          type: "small",
          bold: true
        }, pointValue)));
      } else {
        earnedPoints = pointValue;
      }
    }
    var multiplier;
    // eslint-disable-next-line react/prop-types
    if (multiplierValue && multiplierTemplate && multiplierTemplate.includes(_constant.MULTIPLIER_PLACEHOLDER)) {
      multiplier = replaceByJSX(multiplierTemplate, (0, _defineProperty2.default)({}, _constant.MULTIPLIER_PLACEHOLDER, multiplierValue));
      multiplier = /*#__PURE__*/_react.default.createElement(MultiplierText, {
        accessible: false,
        type: "small",
        bold: true
      }, multiplier);
    }
    var jsxMapping = (_jsxMapping = {}, (0, _defineProperty2.default)(_jsxMapping, _constant.POINT_TEMPLATE, earnedPoints), (0, _defineProperty2.default)(_jsxMapping, _constant.MULTIPLIER_TEMPLATE, multiplier), _jsxMapping);
    var content = replaceByJSX(template, jsxMapping);
    return /*#__PURE__*/_react.default.createElement(Wrapper, (0, _extends2.default)({}, customProperties, {
      tabIndex: tabIndex,
      includedInPriceHeader: includedInPriceHeader
    }), isHotel ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(BigPointIconWrapper, {
      style: {
        marginTop: '2px'
      }
    }, /*#__PURE__*/_react.default.createElement(BigPoints, null)), /*#__PURE__*/_react.default.createElement(TextWrapper, {
      accessible: false,
      theme: themeContext,
      type: "small"
    }, content)) : /*#__PURE__*/_react.default.createElement(TextWrapper, {
      accessible: false,
      theme: themeContext,
      type: "small"
    }, /*#__PURE__*/_react.default.createElement(BigPointIconWrapper, null, /*#__PURE__*/_react.default.createElement(BigPoints, null)), content));
  };
  return themeContext ? getComponent() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getComponent());
};
BigPointToBeEarned.propTypes = _BigPointToBeEarned.default.PropTypes;
BigPointToBeEarned.defaultProps = _BigPointToBeEarned.default.DefaultProps;
var _default = BigPointToBeEarned;
exports.default = _default;